// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__25eb5","clinicsSelect":"TableHeading_clinicsSelect__33Uvx"};